export const AppConfig = {
    api_endpoint: API_ENDPOINT,
    debug: APP_DEBUG,
    states: {
        start: 'Start',
        draw: 'Draw',
        design: 'Design',
        review: 'Review'
    }
}



// WEBPACK FOOTER //
// ./src/js/app-config.constant.js